import { render, staticRenderFns } from "./WriteOffSum.vue?vue&type=template&id=2ac45f0c&scoped=true&"
import script from "./WriteOffSum.vue?vue&type=script&lang=js&"
export * from "./WriteOffSum.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffSum.vue?vue&type=style&index=0&id=2ac45f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac45f0c",
  null
  
)

export default component.exports